// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2m6Qi","boxTitle":"Qualiphy_boxTitle__3eu2n","box":"Qualiphy_box__A50kV","toggleWrap":"Qualiphy_toggleWrap__3dV-B"};